import { Injectable, inject } from '@angular/core';
import { SERVER_CACHE_LOGGER, SERVER_HTTP_CLIENT_LOGGER, SERVER_PERFORMANCE_LOGGER, SERVER_RENDERER_LOGGER } from '../../express.tokens';

export interface LogSink {

  log(
    level: LogLevel,
    message: string,
    ...meta: unknown[]
  ): void;

}

// See node_modules/triple-beam/config/syslog
export enum LogLevel {
  Debug = 'debug',
  Info = 'info',
  Notice = 'notice',
  Warning = 'warning',
  Error = 'error',
  Crit = 'crit',
  Alert = 'alert',
  Emerg = 'emerg',
}

export class Logger {

  public constructor(
    private sink?: LogSink | null,
  ) {}

  private log(
    level: LogLevel,
    message: string,
    ...meta: unknown[]
  ) {
    if (this.sink) {
      this.sink.log(
        level,
        message,
        ...meta,
      );
    } else {
      console.log(message, meta);
    }
  }

  public debug(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Debug, message, ...meta);
  }

  public info(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Info, message, ...meta);
  }

  public notice(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Notice, message, ...meta);
  }

  public warning(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Warning, message, ...meta);
  }

  public error(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Error, message, ...meta);
  }

  public crit(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Crit, message, ...meta);
  }

  public alert(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Alert, message, ...meta);
  }

  public emerg(message: string, ...meta: unknown[]) {
    this.log(LogLevel.Emerg, message, ...meta);
  }

}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {

  private rendererLogger = inject(SERVER_RENDERER_LOGGER, { optional: true });
  private httpClientLogger = inject(SERVER_HTTP_CLIENT_LOGGER, { optional: true });
  private cacheLogger = inject(SERVER_CACHE_LOGGER, { optional: true });
  private performanceLogger = inject(SERVER_PERFORMANCE_LOGGER, { optional: true });

  public renderer = new Logger(this.rendererLogger);
  public httpClient = new Logger(this.httpClientLogger);
  public cache = new Logger(this.cacheLogger);
  public performance = new Logger(this.performanceLogger);

}
